import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { getMenuInfoByPath } from './menuDict';

export const useAutoMenuHighlight = () => {
  const location = useLocation();

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    
    // 优先使用 localStorage 中的完整菜单名
    const localMenu = localStorage.getItem('currentMenu');
    if (localMenu) {
      // 判断是 CheckApproval 还是 ApprovalSummary
      let key = '';
      if (localMenu.includes('Check Approval')) {
        key = 'CheckApproval';
      } else if (localMenu.includes('Approval Summary')) {
        key = 'ApprovalSummary';
      }
      
      if (key) {
        const menuInfo = {
          key: key,
          parentKey: 'AccountPayable',
          label: localMenu
        };
        sessionStorage.setItem('expectedMenu', JSON.stringify(menuInfo));
        // console.log('[AutoMenu] 使用 localStorage:', localMenu);
        localStorage.removeItem('currentMenu');
        return;
      }
    }
    
    // 其他页面（Insurance、Report 等）使用配置映射
    const menuInfo = getMenuInfoByPath(location.pathname, searchParams);
    if (menuInfo) {
      sessionStorage.setItem('expectedMenu', JSON.stringify(menuInfo));
      // console.log('[AutoMenu] 使用配置映射:', menuInfo.label);
    }
  }, [location.pathname, location.search]);
};
